/**
 * AJAX add-to-cart for pixel product pages — opens the cart drawer instead of redirecting.
 * PLR Kickstarter products keep native form submit (redirect to checkout).
 */
(function () {
  function getCartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (item) {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        ids.push(item.dataset.sectionId);
      }
    });
    return ids;
  }

  function openCartDrawer() {
    function tryOpen() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      return false;
    }

    if (tryOpen()) return;

    customElements.whenDefined('cart-drawer-component').then(function () {
      tryOpen();
    });
  }

  function dispatchCartUpdate(cart, variantId, sections) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: String(variantId),
          data: {
            source: 'product-pixel-purchase',
            itemCount: cart.item_count,
            sections: sections,
          },
        },
      })
    );
  }

  function handlePixelPurchaseSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = true;
    }

    const formData = new FormData(form);
    const sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const variantId = formData.get('id');
    const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.message || data.description || 'Could not add to cart');
        }

        return fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            dispatchCartUpdate(cart, variantId, data.sections);
            openCartDrawer();
          });
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        if (submitButton instanceof HTMLButtonElement) {
          submitButton.disabled = false;
        }
      });
  }

  function initPixelPurchaseForms() {
    document.querySelectorAll('.product-information--pixel form[action*="/cart/add"]').forEach(function (form) {
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.pixelPurchaseReady === 'true') return;
      if (form.querySelector('input[name="return_to"]')) return;

      form.dataset.pixelPurchaseReady = 'true';
      form.addEventListener('submit', handlePixelPurchaseSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPixelPurchaseForms);
  } else {
    initPixelPurchaseForms();
  }

  document.addEventListener('shopify:section:load', initPixelPurchaseForms);
})();
